import { useState, useEffect } from 'react';
import { Icon } from 'components/Atoms/Icon/Icon';
import { Dialog } from 'components/Atoms/Dialog/Dialog';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import { useScreenSize } from 'utils/useScreenSize';
import styles from './SharePage.module.scss';
import {
  blueSkyShareUrl,
  emailShareUrl,
  facebookShareUrl,
  linkedinShareUrl,
  nextdoorShareLink,
  twitterShareUrl,
  whatsappShareUrl,
} from './helpers';

export function SharePage() {
  const [open, setOpen] = useState(false);
  const [currentUrl, setCurrentUrl] = useState('');
  const [currentTitle, setCurrentTitle] = useState('');
  const { t } = useTranslation();
  const { isMobileView } = useScreenSize();
  useEffect(() => {
    setCurrentUrl(window?.location?.href || '');
    setCurrentTitle(document?.title || '');
  }, []);

  const shareLinks = {
    facebook: facebookShareUrl(currentUrl),
    twitter: twitterShareUrl(currentTitle, currentUrl),
    nextdoor: nextdoorShareLink(currentUrl, currentTitle),
    linkedin: linkedinShareUrl(currentUrl),
    blueSky: blueSkyShareUrl(currentUrl),
    whatsapp: whatsappShareUrl(currentUrl),
    email: emailShareUrl(currentTitle, currentUrl),
  };
  const handleCopyLink = () => {
    navigator.clipboard.writeText(currentUrl);
    setOpen(false);
  };

  return (
    <>
      <button
        type="button"
        className={styles.shareButton}
        onClick={() => setOpen(true)}
        aria-label={t('sharePage.title')}
      >
        <Icon name="share" color="currentColor" />
      </button>
      {open && (
        <Dialog
          open={open}
          setOpen={setOpen}
          anchorBottom={isMobileView}
          title={
            <div className={styles.dialogHeader}>
              <div className={styles.dialogHeaderInner}>
                <div>{t('sharePage.title')}</div>
                <button type="button" onClick={() => setOpen(false)}>
                  <Icon name="close" />
                </button>
              </div>
            </div>
          }
          content={
            <div className={styles.shareContainer}>
              <Link href={shareLinks.facebook} target="_blank" className={styles.shareLink}>
                <Icon name="facebook" ariaHidden />
                {t('sharePage.facebook')}
              </Link>
              <Link href={shareLinks.twitter} target="_blank" className={styles.shareLink}>
                <Icon name="twitter" ariaHidden />
                {t('sharePage.twitter')}
              </Link>
              <Link href={shareLinks.nextdoor} target="_blank" className={styles.shareLink}>
                <Icon name="nextdoor" ariaHidden />
                {t('sharePage.nextdoor')}
              </Link>
              <Link href={shareLinks.linkedin} target="_blank" className={styles.shareLink}>
                <Icon name="linkedin" ariaHidden />
                {t('sharePage.linkedin')}
              </Link>
              <Link href={shareLinks.blueSky} target="_blank" className={styles.shareLink}>
                <Icon name="blueSky" ariaHidden />
                {t('sharePage.blueSky')}
              </Link>
              <Link href={shareLinks.whatsapp} target="_blank" className={styles.shareLink}>
                <Icon name="whatsapp" ariaHidden />
                {t('sharePage.whatsapp')}
              </Link>
              <button type="button" className={styles.shareLink} onClick={handleCopyLink}>
                <Icon name="link" ariaHidden />
                {t('sharePage.copyLink')}
              </button>
              <Link href={shareLinks.email} target="_blank" className={styles.shareLink}>
                <Icon name="mail" ariaHidden />
                {t('sharePage.email')}
              </Link>
            </div>
          }
        />
      )}
    </>
  );
}
